import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reportdashboard',
  templateUrl: './reportdashboard.component.html',
  styleUrl: './reportdashboard.component.scss'
})
export class ReportdashboardComponent implements OnInit {
  placeholders = environment.placeholders as { [key: string]: string };
  reportPlaceHolders:any

  constructor(private router: Router){
    this.reportPlaceHolders = this.placeholders['Reports_page']
  }

  ngOnInit (){

  }

  generateReport(reportId: number) {
    switch (reportId) {
      case 1:
        this.router.navigate(['/reports']);
        break;
      case 2:
        this.router.navigate(['/dealreports']);
        break;
      case 3:
        this.router.navigate(['/eventreport']);
        break;
      default:
        console.log("Invalid Report Selection");
    }
  }
}
